import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Tab, Tabs } from '@rossum/ui/material';
import { isTrialSelector } from '../../../../redux/modules/organization/selectors';
import { hasSubscriptionPlanExistSelector } from '../../../pricing/selectors';

export const billingSections = [
  { route: 'my-plan', label: 'myPlan' },
  { route: 'overview', label: 'overview' },
  { route: 'statistics', label: 'usage' },
  { route: 'history', label: 'history' },
] as const;

export const BillingHeaderTabs = ({
  currentSection,
}: {
  currentSection: (typeof billingSections)[number];
}) => {
  const intl = useIntl();
  const isPricingActive = useSelector(hasSubscriptionPlanExistSelector);
  const isTrial = useSelector(isTrialSelector);
  const { push } = useHistory();

  return (
    <Tabs
      value={currentSection.route}
      onChange={(_, value) => push(`/billing/${value}`)}
    >
      {billingSections
        .filter(section => (section.route === 'history' ? !isTrial : true))
        .filter(section =>
          section.route === 'my-plan' ? isPricingActive : true
        )
        .map(section => (
          <Tab
            key={section.route}
            value={section.route}
            label={intl.formatMessage({
              id: `containers.billing.${section.label}`,
            })}
            data-cy={`billing-${section.route}`}
          />
        ))}
    </Tabs>
  );
};
